var _circle, _circle2, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 92,
    fill: "white",
    stroke: "#0d9488",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78,
    fill: "#f0fdfa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 52,
    width: 36,
    height: 96,
    rx: 8,
    fill: "#0d9488"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 82,
    width: 96,
    height: 36,
    rx: 8,
    fill: "#0d9488"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 88 C90 82 95 78 100 82 C105 78 110 82 110 88 C110 96 100 104 100 104 C100 104 90 96 90 88Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100 L82 100 L88 90 L94 110 L100 95 L106 105 L112 100 L132 100",
    stroke: "white",
    strokeWidth: 2.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEternal);
export default __webpack_public_path__ + "static/media/logo-eternal.4272e5c24d8c31ddabf131e4f835da3e.svg";
export { ForwardRef as ReactComponent };